module.exports = __webpack_public_path__ + "media/application/images/wjc-unesco-white-c8e085a0b1b18dd6cf7075650f5210838bd8767c8eeedfe5a61ef988109eebee.png";